<template>
<nav id="sidebar" :class="this.sidemenu_minimized" style="display: flex; flex-direction: column;">
    <div class="sidebar-header">
    <div @click="toggleToIcons()" style="margin-left: 5px;">
        <i class="fa fa-bars fa-1x"></i>
        <span class="menu-item-name app-heading">Expand/Collapse</span></div>
    </div>
   <ul class="list-unstyled">
     <li class="active" >
         <router-link to="/admin-dashboard">
         <i class="fa fa-home"></i>
         <span class="menu-item-name">Home</span>
         </router-link>
     </li>
     <li>
        <router-link to="/account-lookup" :class="[currentPage.includes('account-lookup', 'account-lookup/view-list') ? activeClass : '']">
        <i class="fa fa-user-o"></i>
        <span class="menu-item-name">Account Lookup</span>
        </router-link>
     </li>
     <li>
        <router-link to="/enterprise-lookup" :class="[currentPage.includes('enterprise-lookup', 'enterprise-lookup/view-list') ? activeClass : '']">
        <i class="fa fa-users"></i>
        <span class="menu-item-name">Enterprise Lookup</span>
        </router-link>
     </li>
     <li>
        <router-link to="/customer-accounts-view-list" >
        <i class="fa fa-user-o"></i>
        <span class="menu-item-name">New Accounts</span>
        </router-link>
     </li>
     <li>
        <router-link to="/view-affiliate-list" >
        <i class="fa fa-connectdevelop"></i>
        <span class="menu-item-name">Affiliate Manager</span>
        </router-link>
     </li>
     <li>
        <router-link to="/list-accounts" >
        <i class="fa fa-list-alt"></i>
        <span class="menu-item-name">Mentors/Mentees</span>
        </router-link>
     </li>
     <li>
        <router-link to="/listusers" >
        <i class="fa fa-list"></i>
        <span class="menu-item-name">List Users</span>
        </router-link>
     </li>
     <li>
        <router-link to="/add-account" >
        <i class="fa fa-user"></i>
        <span class="menu-item-name">Add Account</span>
        </router-link>
     </li>
     <li>
       <router-link to="/add-admin" >
       <i class="fa fa-user-secret"></i>
       <span class="menu-item-name">Add Master Admin</span>
       </router-link>
     </li>
     <li>
       <router-link to="/add-researcher" >
       <i class="fa fa-user"></i>
       <span class="menu-item-name">Add Researcher</span>
       </router-link>
     </li>
     <li>
       <router-link to="/add-csr" >
       <i class="fa fa-user"></i>
       <span class="menu-item-name">Add CSR</span>
       </router-link>
     </li>
     <li>
       <router-link to="/naics-list" >
       <i class="fa fa-list-ol"></i>
       <span class="menu-item-name">NAICS Manager</span>
       </router-link>
     </li>
     <li>
       <router-link to="/notification-manager-list" >
       <i class="fa fa-list-ol"></i>
       <span class="menu-item-name">Notification Manager</span>
       </router-link>
     </li>
      <li>
       <router-link to="/subscription-list" >
       <i class="fa fa-list-ol"></i>
       <span class="menu-item-name">Manage Subscriptions</span>
       </router-link>
     </li>
     <li>
       <router-link to="/course-list" >
       <i class="fa fa-list-ol"></i>
       <span class="menu-item-name">Manage Course</span>
       </router-link>
     </li>
     <li>
       <router-link to="/import/prospect-accounts" >
       <i class="fa fa-list-ol"></i>
       <span class="menu-item-name">Import Accounts</span>
       </router-link>
     </li>
     
  </ul>
 <ul class="list-unstyled">
   <li class="active">
     <b-link v-b-toggle="'collapse-buildable-submenu'">
     <!-- <i class="fa fa-line-chart"></i> -->
     <img src="@/assets/buildable-items-icon.png"  width="25" height="25" alt="Buildable Items" />
     <span class="menu-item-name">Buildable Items
     <i class="fa fa-angle-down report-dropdown" style="font-size: 20px;"></i>
     </span>
     </b-link>
   </li>
   <b-collapse v-bind:id="'collapse-buildable-submenu'">
   <ul class="nav flex-column ml-3">
     <li>
        <router-link to="/masteradmin-pathway-catalog" >
        <i class="fa fa-tasks"></i>
        <span class="menu-item-name">Pathway Catalog</span>
        </router-link>
     </li>
     <li>
        <router-link to="/view-tasklist" >
        <i class="fa fa-tasks"></i>
        <span class="menu-item-name">Skill Set</span>
        </router-link>
     </li>
     <li>
         <router-link to="/task-library" >
         <i class="fa fa-book"></i>
         <span class="menu-item-name">Task Library</span>
         </router-link>
     </li>
     <li>
       <router-link to="/assessment-builder-list" >
       <i class="fa fa-list-ol"></i>
       <span class="menu-item-name">Assessments</span>
       </router-link>
     </li>
     <li>
       <router-link to="/assessment-section-list" >
       <i class="fa fa-list-ol"></i>
       <span class="menu-item-name">Assessment Sections</span>
       </router-link>
     </li>
     <li>
       <router-link to="/forms-manager">
       <i class="fa fa-list-ol"></i>
       <span class="menu-item-name">Forms Manager</span>
       </router-link>
     </li>
     <li>
       <router-link to="/introduction-manager-list">
       <i class="fa fa-list-ol"></i>
       <span class="menu-item-name">Introduction Manager</span>
       </router-link>
     </li>
     <li>
       <router-link to="/view-certification-manager" >
       <i class="fa fa-list-ol"></i>
       <span class="menu-item-name">Certification Manager</span>
       </router-link>
     </li>
   </ul>
   </b-collapse>
</ul>

  <div class="heading-seperator"></div>
     <ul class="list-unstyled">
       <li class="active">
         <b-link v-b-toggle="'collapse-report-submenu'">
         <i class="fa fa-line-chart"></i>
         <span class="menu-item-name">Reports
         <i class="fa fa-angle-down report-dropdown" style="font-size: 20px;"></i>
         </span>
         </b-link>
       </li>
       <b-collapse v-bind:id="'collapse-report-submenu'">
       <ul class="nav flex-column ml-3">
         <li>
           <router-link to="/account-report">
           <i class="fa fa-user-o"></i>
           <span class="menu-item-name">Account Report</span>
           </router-link>
         </li>
         <li class="nav-item">
           <router-link to="/account-contact-report">
           <i class="fa fa-user-o"></i>
           <span class="menu-item-name">Account Contact Report</span>
           </router-link>
         </li>
         <li class="nav-item">
           <router-link to="/activity-report">
           <i class="fa fa-user-o"></i>
           <span class="menu-item-name">Activity Report</span>
           </router-link>
         </li>
          <li class="nav-item">
           <router-link to="/flash-report">
           <i class="fa fa-user-o"></i>
           <span class="menu-item-name">Flash Report</span>
           </router-link>
         </li>
          <li class="nav-item">
           <router-link to="/usage-report">
           <i class="fa fa-user-o"></i>
           <span class="menu-item-name">Usage Report</span>
           </router-link>
         </li>
         <li class="nav-item">
           <router-link to="/mentee-report">
           <i class="fa fa-user-o"></i>
           <span class="menu-item-name">Mentee Report</span>
           </router-link>
         </li>
         <li class="nav-item">
           <router-link to="/customer-success-report">
           <i class="fa fa-user-o"></i>
           <span class="menu-item-name">Customer Success</span>
           </router-link>
         </li>
       </ul>
       </b-collapse>
    </ul>

    <ul class="list-unstyled list-signout-menu">
      <li>
      <router-link to="/logout">
      <i class="fa fa-sign-out"></i>
      <span class="menu-item-name">Sign Out</span>
      </router-link>
      </li>
   </ul>
</nav>
</template>

<script>
export default {
  data() {
    return {
      activeClass: 'nav-active',
      sidemenu_minimized: '',
    }
  },
  computed: {
    currentPage() {
      return this.$route.path;
    }
  },
  methods: {
   toggleToIcons() {
     document.getElementById('sidebar').classList.toggle("active");
     let minimized = '';
     if(document.getElementById('sidebar').classList == 'active')
     {
        minimized = 'active';
     }
     this.$store.dispatch('sidebar_menu_minimized', minimized);
   }
  },
  created() {
    this.sidemenu_minimized = this.$store.state.sidebar_menu_minimized;
    document.body.className = 'ma-body-bgcolor';
  }
}
</script>

<style>
.heading-seperator {
  /* border-bottom: 2px solid #dc2227; */
  border-bottom: 2px solid #00ACEE;
  margin: 10px 10px 0px 10px;
}
.heading {
  font-size: 15px;
  padding-left: 20px;
}
#sidebar {
    min-width: 250px;
    max-width: 250px;
    background-color: #D4D4D4;
    min-height: 100vh;
    transition: opacity 2s linear;
    transform:translate(0);
    opacity: 1;
    padding-top: 100px;
}
#sidebar.active {
    min-width: 60px;
    max-width: 60px;
    text-align: center;
}
#sidebar.active .menu-item-name {
   display: none;
}
#sidebar.active .sidebar-header h3 {
    display: none;
}

#sidebar.active .sidebar-header strong {
    display: block;
}

#sidebar ul li a {
    text-align: left;
    text-decoration: none;
}

#sidebar.active ul li a {
    padding: 0px 10px;
    text-align: center;
    font-size: 0.85em;
    text-decoration: none;
}

#sidebar.active ul li a i {
    margin-right: 0;
    display: block;
    font-size: 16px;
}

#sidebar.active ul ul a {
    padding: 10px !important;
}

#sidebar.active .dropdown-toggle::after {
    top: auto;
    bottom: 10px;
    right: 50%;
    -webkit-transform: translateX(50%);
    -ms-transform: translateX(50%);
    transform: translateX(50%);
}

#sidebar .sidebar-header {
    padding: 0px 10px 10px 10px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
}

#sidebar ul.components {
    padding: 5px 0;
    border-bottom: 1px solid #47748b;
}
#sidebar ul li a {
    padding: 0px 10px 0px 10px;
    display: block;
    color: #212529;
    margin-left: 5px;
}
#sidebar ul ul li a {
    padding: 2px;
}
#sidebar ul li a i {
    margin-right: 10px;
}
#sidebar ul li.active>a,
#sidebar a[aria-expanded="true"] {
    color: #212529;
}
a[data-toggle="collapse"] {
    position: relative;
}
.dropdown-toggle::after {
    display: block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
}
.app-heading {
 margin-left: 10px;
}
.list-signout-menu {
  bottom: 0px;
  margin-top: auto;
}
.report-dropdown {
  float: right;
  font-size: 20px;
}
#sidebar.active ul ul {
  display: none;
}
#sidebar ul li {
  padding-top: 10px;
  padding-bottom: 10px;
}
#sidebar ul li a.nav-active, #sidebar ul li a.router-link-exact-active {
  /* border-left: 3px solid red; */
  border-left: 3px solid #00ACEE;
  margin-left: 2px;
}
#sidebar ul li a i {
  width: 15px;
}
#sidebar.active ul li a i {
  width: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/masteradmin_sidebar_menu.vue